import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { getTextByKey } from '@feedback/utils/util'
import { getPageConfig } from '@feedback/utils/CONST'
import './index.scss'
import clsx from 'clsx'
import { extend, RequestResponse } from 'umi-request'
import { InputItem, Button, DatePicker, Toast } from 'antd-mobile'
import { getAppConfig } from '@feedback/utils/CONST'
import { addNetworkLog } from '@/projects/feedback/services/index'

interface IHeader {
  scrollTop: number
}

interface IContent {
  urlDictList: IurlDict[]
}

interface IFooter {
  TextStatus: number
  setTextStatus: Dispatch<SetStateAction<number>>
  toText: Function
  seturlDictList: Dispatch<SetStateAction<any>>
}

interface IurlDict {
  name: string
  url: string
  status: number
  speed: string
  message: string
}

const request = extend({
  timeout: 30 * 1000
})

let isDown = false

const statusIconObject: { [key: number]: any } = {
  // 未请求
  0: {
    dot: <i className='round-b__left-laber--graydot' />,
    icon: null
  },
  // 成功
  200: {
    dot: <i className='round-b__left-laber--greendot' />,
    icon: <i className='round-b__right-laber--greenicon' />
  },
  // 请求中
  300: {
    dot: null,
    icon: <i className='round-b__right-laber--loadicon' />
  },
  // 失败
  400: {
    dot: <i className='round-b__left-laber--reddot' />,
    icon: <i className='round-b__right-laber--redicon' />
  },
  // 超时
  408: {
    dot: <i className='round-b__left-laber--reddot' />,
    icon: <i className='round-b__right-laber--redicon' />
  }
}

const urlDict = [
  {
    name: 'Alibaba',
    url: 'https://cdnoss.stardustgod.com/testing',
    status: 0,
    speed: '',
    message: ''
  },
  {
    name: 'Alibaba2',
    url: 'https://sd-cms-cloud-prod.crazymaplestudios.com/testing.png',
    status: 0,
    speed: '',
    message: ''
  },
  {
    name: 'Google',
    url: 'https://cdnoss.stardusttime.com/testing',
    status: 0,
    speed: '',
    message: ''
  },
  {
    name: 'Amazon',
    url: 'https://d2uld9k3qk9zxu.cloudfront.net/testing',
    status: 0,
    speed: '',
    message: ''
  },
  {
    name: 'Akamai',
    url: 'https://chaptersakm.akamaized.net/testing',
    status: 0,
    speed: '',
    message: ''
  },
  {
    name: 'Akamai2',
    url: 'https://sd-cms-cloud-prod2.crazymaplestudios.com/testing.png',
    status: 0,
    speed: '',
    message: ''
  }
]

const Header: React.FC<IHeader> = ({ scrollTop }) => {
  const isSticky = scrollTop >= (350 - 192) / 2
  const calcOpacity = scrollTop <= 0 ? 1 : 7.2 / scrollTop
  const { appid, logoShadow, bg, bgSearch, poster } = getAppConfig() || {}

  return (
    <>
      {isSticky ? <div style={{ height: 79 }}>&nbsp;</div> : null}
      <header className={clsx('faq-header', isSticky && 'is-sticky')}>
        {!isSticky ? (
          <>
            {bg && (
              <div
                className='faq-header__bg'
                style={{ backgroundImage: `url(${bg})` }}
              />
            )}
            {poster && (
              <div
                className='faq-header__poster'
                style={{
                  opacity: calcOpacity,
                  backgroundImage: `url(${poster})`
                }}
              />
            )}
            {scrollTop <= 10 && !isSticky ? (
              <section>
                <h2 className='faq-header__h2'>
                  {getTextByKey('Network Status')}
                </h2>
              </section>
            ) : null}
          </>
        ) : (
          <>
            <div
              className='faq-header__bg-search'
              style={{ backgroundImage: `url(${bgSearch})` }}
            />
            <div className='faq-header__title'>&nbsp;</div>
          </>
        )}
        {logoShadow && (
          <Link to='/questionIndex'>
            <div
              className={clsx(
                'faq-header__logo',
                'is-shadow',
                scrollTop > 0 ? 'is-fixed' : ''
              )}
              style={{ backgroundImage: `url(${logoShadow})` }}
            />
          </Link>
        )}
        {['cm1006', 'cm1007']?.includes(appid) && (
          <div className='round-b'></div>
        )}
      </header>
    </>
  )
}

const Content: React.FC<IContent> = ({ urlDictList }) => {
  return (
    <div className='round-b'>
      {urlDictList.map((item) => (
        <div className='round-b__divs'>
          <div className='round-b__div'>
            <span className='round-b__left-laber'>
              {statusIconObject[item.status].dot}
              {item.name}
            </span>
            <span className='round-b__right-laber'>
              {item.status == 300
                ? getTextByKey('Testing')
                : item.status == 200
                ? item.speed + 'k/s'
                : '--'}
              {statusIconObject[item.status].icon}
            </span>
          </div>
        </div>
      ))}
    </div>
  )
}

const Footer: React.FC<IFooter> = ({
  TextStatus,
  setTextStatus,
  toText,
  seturlDictList
}) => {
  const history = useHistory()

  const onYes = () => {
    isDown = true
    setTextStatus(1)
    toText()
  }

  const onBACK = () => {
    history.goBack()
  }

  const onCancel = () => {
    isDown = false
    seturlDictList(JSON.parse(JSON.stringify(urlDict)))
    setTextStatus(0)
  }

  const onOk = () => {
    history.push('/questionIndex')
  }

  if (TextStatus == 0) {
    return (
      <footer className='network-check-footer'>
        <p>
          {getTextByKey(
            'Please allow us to access your network status information to help solve the issue.'
          )}
        </p>
        <div className='network-check-footer__btn'>
          <Button className='network-check-footer__btn--BACK' onClick={onBACK}>
            {getTextByKey('back')}
          </Button>
          <Button className='network-check-footer__btn--YES' onClick={onYes}>
            {getTextByKey('Yes')}
          </Button>
        </div>
      </footer>
    )
  } else if (TextStatus == 1) {
    return (
      <footer className='network-check-footer'>
        <p>
          {getTextByKey(
            'Network testing is in progress. It may take 10–30 seconds. Please wait.'
          )}
        </p>
        <div className='network-check-footer__Cancel'>
          <a href='javsscript:;' onClick={onCancel}>
            {getTextByKey('cancel')}
          </a>
        </div>
      </footer>
    )
  } else {
    return (
      <footer className='network-check-footer'>
        <p>{getTextByKey('Done! Thank you!')}</p>
        <div className='network-check-footer__OK'>
          <Button onClick={onOk}>{getTextByKey('back')}</Button>
        </div>
      </footer>
    )
  }
}

const NetworkCheck = () => {
  const [scrollTop, setScrollTop] = useState(0)
  const [TextStatus, setTextStatus] = useState(0)
  const [urlDictList, seturlDictList] = useState<IurlDict[]>(
    JSON.parse(JSON.stringify(urlDict))
  )
  const { appid } = getPageConfig()

  const onScroll = (event: any) => {
    setScrollTop(event.target?.documentElement?.scrollTop || 0)
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  // 延时返回
  function delayPromise(ms: number) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms)
    })
  }

  // 设置超时函数
  function timeoutPromise(promise: Promise<RequestResponse>, ms: number) {
    var timeout = delayPromise(ms).then(function () {
      throw new Error('Operation timed out after ' + ms + ' ms')
    })

    return Promise.race([promise, timeout])
  }

  const curl = (url: string): Promise<RequestResponse> => {
    return new Promise(function (resolve, reject) {
      try {
        const res = request(url, {
          method: 'get',
          getResponse: true
        })
        resolve(res)
      } catch {
        reject('timeout')
      }
    })
  }

  // 开始测试
  const toText = async () => {
    const _urlDictList = JSON.parse(JSON.stringify(urlDictList))
    for (let i = 0; i < _urlDictList.length; i++) {
      if (!isDown) {
        seturlDictList(JSON.parse(JSON.stringify(urlDict)))
        return
      }
      urlDictList[i] = {
        ...urlDictList[i],
        status: 300
      }
      seturlDictList([...urlDictList])
      try {
        let startAt = new Date().getTime()
        const res = await timeoutPromise(curl(urlDictList[i].url+`?time=${new Date().getTime()}`), 30 * 1000)
        const length = Number(res.response.headers.get('Content-Length'))
        let endAt = new Date().getTime()

        // 计算速度
        const duration = Number(endAt - startAt)
        const speed = (length / duration).toFixed(2)

        urlDictList[i] = {
          ...urlDictList[i],
          status: res.response.status,
          speed,
          message: 'success'
        }
        seturlDictList([...urlDictList])
      } catch (err: any) {
        console.log(err, err.toString(), 'err')
        let state = 400
        if (err.toString().includes('timed out')) {
          state = 408
        }

        urlDictList[i] = {
          ...urlDictList[i],
          status: state,
          speed: '0',
          message: err.toString()
        }
        seturlDictList([...urlDictList])
      }
    }
    addNetworkLog({ detail: urlDictList })
    setTextStatus(2)
  }

  return (
    <>
      <div className={clsx('network-check', appid)}>
        <Header scrollTop={scrollTop} />
        <Content urlDictList={urlDictList} />

        <Footer
          TextStatus={TextStatus}
          setTextStatus={setTextStatus}
          toText={toText}
          seturlDictList={seturlDictList}
        />
      </div>
    </>
  )
}

export default NetworkCheck
